import { maxWidth600 } from "themes/default/breakpoints"
import { theme } from "themes/default/theme"
export const styles = {
  avatar: {
    width: 35,
    height: 35,
    mr: ".5rem",
  },
  groupSelectorButton: {
    textTransform: "none",
    color: "white",
    p: 0,
    [maxWidth600]: {
      "& .MuiButton-endIcon": {
        ml: 0,
      },
    },
  },
  menuHeaderLink: {
    cursor: "pointer",
    color: "#4183c4",
    textTransform: "none",
    p: 0,
    "&:hover": {
      backgroundColor: "transparent",
    },
  },
  groupList: {
    flexWrap: "nowrap",
    overflowY: "auto",
    maxHeight: "400px",
    // minHeight: "150px",
    // height: "calc(100vh - 150px)",
    // justifyContent: "safe center",
    alignItems: "safe stretch",
  },
  grouptem: (theme) => ({
    width: "100%",
    mt: ".2rem",
    p: ".5rem",
    border: `1px solid ${theme.palette.border.primary}`,
    textAlign: "left",
    pr: 3.75,
    position: "relative",
    cursor: "pointer",
    flexWrap: "nowrap",
    alignItems: "center",
    backgroundColor: theme.palette.background.card,
    "&:hover": {
      backgroundColor: theme.palette.primary.lighter,
    },
  }),
  groupAvatar: {
    width: 30,
    height: 30,
    mr: ".5rem",
  },
  groupName: (theme) => ({
    maxWidth: "350px",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    flexGrow: 1,
    color: theme.palette.common.black,
  }),
  groupButton: {
    position: "absolute",
    right: 10,
    top: "50%",
    transform: "translateY(-50%)",
    ml: "1rem",
    color: theme.palette.primary.main,
    fontSize: 14,
  },
  groupSelected: (theme) => ({
    maxWidth: "160px",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    color: theme.palette.common.white,
  }),
}
